import { Box, Text } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import Image, { StaticImageData } from 'next/legacy/image';
import React from 'react';
import styles from './ArtistInfoBadges.module.scss';
import featuredBadge from './featured-badge.svg';
import { artistBadgeMessages } from './messages';
import starBadge from './star-badge.svg';

interface BadgeProps {
  src: string | StaticImageData;
  text: string;
}

const Badge: React.FC<BadgeProps> = ({ src, text }) => {
  return (
    <Box className={styles.badgeField}>
      <Image src={src} alt="" width={24} height={24} />
      <Text type="body2" className={styles.badgeTitle}>
        {text}
      </Text>
    </Box>
  );
};

export interface ArtistInfoBadgesProps {
  fanArtist?: boolean;
  featuredArtist?: boolean;
}

export const ArtistInfoBadges: React.FC<ArtistInfoBadgesProps> = ({
  fanArtist,
  featuredArtist,
}) => {
  const intl = useIntl();
  if (!fanArtist && !featuredArtist) {
    return null;
  }

  return (
    <Box className={styles.badgesContainer}>
      {fanArtist && (
        <Badge
          key="fan-artist-badge"
          src={starBadge}
          text={intl.formatMessage(artistBadgeMessages.fanArtBadgeText)}
        />
      )}
      {featuredArtist && (
        <Badge
          key="featured-artist-badge"
          src={featuredBadge}
          text={intl.formatMessage(artistBadgeMessages.featuredBadgeText)}
        />
      )}
    </Box>
  );
};
